import React, {useState, useEffect} from 'react';
import s from './CreateInvoice.module.css';
import FunctionalButtonPanel from '../../Components/FunctionalButtonPanel/FunctionalButtonPanel';
import CreateInvoicePopup from './CreateInvoicePopup/CreateInvoicePopup';
import InvoiceTypeSelect from './components/InvoiceTypeSelect';
import {Form, Formik} from 'formik';
import {CreateInvoiceType} from '../../types/TypesStore';
import {useTranslation} from 'react-i18next';
//import ListOfWarehouses from './components/ListOfWarehouses';
import CategorySelectorsList from './components/CategorySelectorsList';
import BackToOffice from '../../Components/Buttons/BackToOffice';
import SearchByNameInput from './components/SearchByNameInput';
import {useParams} from 'react-router-dom';
import DepotProductsList from '../../Components/DepotComponents/DepotProductsList';
import LightGreenButton from '../../Components/Buttons/LightGreenButton';
import {useSelector} from 'react-redux';
import {RootState} from '../../redux/store';
import {useCreateInvoiceDesignForm} from '../../hooks/useCreateInvoiceDesignForm';
import {useSubmitInvoice} from '../../hooks/useSubmitInvoice';
import {scrollToProducts} from '../../assets/utils/utils';
import TopPageInfoBlock from '../../Components/TopPageInfoBlock/TopPageInfoBlock';
import {validateCreateInvoice} from '../../assets/utils/validation';

const CreateInvoice = () => {
	const [resetCategoriesKey, setResetCategoriesKey] = useState(0);
	const {id} = useParams();
	const {t} = useTranslation();

	const user = useSelector((state: RootState) => state.userData.userView);

	const {
		setOrderType,
		setCategoryId,
		searchByName,
		selectedProducts,
		createPopup,
		isLoadingProductList,
		productsForRender,
		functionalityButtons,
		data,
		isOrderData,
		handleClickButtonInPanel,
		handleChangeProduct,
		handleChangeSearch,
		handleClickReadyButton,
		closePopup,
		setSearchByName,
	} = useCreateInvoiceDesignForm('income', id, 'order');

	const {submitInvoice} = useSubmitInvoice();

	// Автоматически закрываем попап, если все товары удалены
	useEffect(() => {
		if (createPopup && selectedProducts.length === 0) {
			closePopup();
		}
	}, [selectedProducts.length, createPopup, closePopup]);

	const initialValues: CreateInvoiceType = {
		type: data && id && isOrderData(data) ? data.type : 'income',
		country: user?.location ?? '',
		address_id: data && id && isOrderData(data) ? data.address_id : '',
		comment: data && id && isOrderData(data) ? (data.comment ?? '') : '',
		points: data && id && isOrderData(data) ? (data.points ?? '') : '',
		money: data && id && isOrderData(data) ? (data.money ?? '') : '',
		products: data && id ? data.products : [],
		contact_id: data && id && isOrderData(data) ? data.contact_id : '',
		order_id: data && id && isOrderData(data) ? data.order_id : '',

		ware_id: data && id && isOrderData(data) ? data.ware_id : '92582',
		service_type: data && id && isOrderData(data) ? data.service_type : '',
	};
	const resetAllFilters = () => {
		setCategoryId(undefined);
		setResetCategoriesKey((k) => k + 1);
		setSearchByName('');
	};
	const handleSubmit = async (
		values: CreateInvoiceType,
		{setFieldTouched}: any,
	) => {
		// Помечаем все поля как touched для отображения ошибок
		const fieldsToTouch = [
			'type',
			'country',
			'ware_id',
			'contact_id',
			'address_id',
			'points',
			'money',
			'products',
		];
		fieldsToTouch.forEach((field) => setFieldTouched(field, true));

		await submitInvoice(values, selectedProducts);
	};

	const scrollToList = () => {
		scrollToProducts(data?.products?.length ?? 5);
	};
	return (
		<main className="page">
			<div className="page__content container">
				<BackToOffice />
				{/*<div className={`${s.mainImage} ${s.createInvoice}`} />*/}
				<div className={s.title}>{t('Створення накладної')}</div>
				<div className={s.infoBlock}>
					<TopPageInfoBlock
						text={
							'Спочатку оберіть тип: замовлення чи повернення. Далі внизу сторінки буде таблиця зі всіма товарами. Ви можете знайти потрібний по пошуку по назві. Також спочатку обрати категорію та підкатегорію. Щоб знов побачити всі треба натиснути "Показати всі". Якщо ви хочете подивитися які товари у вас на складі відсутні, то кнопка "Закінчилися". Якщо хочете подивитися тільки ті товари зі списку, які доступні до замовлення, то кнопка "В наявності"'
						}
						subText={''}
					/>
				</div>

				<Formik<CreateInvoiceType>
					initialValues={initialValues}
					validationSchema={validateCreateInvoice}
					onSubmit={handleSubmit}
					enableReinitialize
				>
					{({handleSubmit, values, errors, touched}) => (
						<Form onSubmit={handleSubmit}>
							<InvoiceTypeSelect setOrderType={setOrderType} />
							{(errors.type ||
								errors.country ||
								errors.ware_id ||
								errors.products) && (
								<div className={s.generalErrors}>
									<div className={s.errorTitle}>{t('Помилки в формі:')}</div>
									{errors.type && touched.type && (
										<div className={s.errorMessage}>{errors.type}</div>
									)}
									{errors.country && touched.country && (
										<div className={s.errorMessage}>{errors.country}</div>
									)}
									{errors.ware_id && touched.ware_id && (
										<div className={s.errorMessage}>{errors.ware_id}</div>
									)}
									{errors.products && touched.products && (
										<div className={s.errorMessage}>
											{Array.isArray(errors.products)
												? errors.products.map((error, index) => (
														<div key={index}>{JSON.stringify(error)}</div>
													))
												: String(errors.products)}
										</div>
									)}
								</div>
							)}
							<div className={s.listOfWarehouses}>
								{/*{(values.type === 'income' || values.type === 'outcome') && (
									<ListOfWarehouses />
								)}*/}
							</div>
							<CategorySelectorsList
								key={resetCategoriesKey}
								fieldName={'categoryId'}
								setCategoryId={setCategoryId}
								scrollToList={scrollToList}
							/>
							<div className={s.buttonPanelWrapper}>
								<FunctionalButtonPanel
									callback={(id: string) => {
										if (id === 'all') {
											resetAllFilters();
										}
										handleClickButtonInPanel(id);
									}}
									functionality={functionalityButtons}
									elWidth={'0 0 175px'}
								/>
							</div>
							<div className={s.flexBetween}>
								<SearchByNameInput
									value={searchByName}
									onChange={handleChangeSearch}
								/>
								{selectedProducts.length > 0 && values.type !== '' && (
									<LightGreenButton
										type={'button'}
										text={t('Підтвердити товари')}
										onClick={handleClickReadyButton}
									/>
								)}
							</div>
							{productsForRender && (
								<DepotProductsList
									isLoading={isLoadingProductList}
									products={productsForRender}
									changeProductCallback={handleChangeProduct}
									isEditing={!!id}
								/>
							)}
							{createPopup && selectedProducts.length > 0 && (
								<CreateInvoicePopup
									close={closePopup}
									prepareProducts={selectedProducts}
									changeProductCallback={handleChangeProduct}
								/>
							)}
						</Form>
					)}
				</Formik>
			</div>
		</main>
	);
};

export default CreateInvoice;
